


































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import dayjs from 'dayjs';
import { ValidationObserver } from 'vee-validate';

import api from '@/libs/api';
import LayoutTitle from '@/components/LayoutTitle.vue';
import SearchIcon from 'mdi-vue/Magnify';
import FileIcon from 'mdi-vue/File';
import LayoutContent from '@/components/LayoutContent.vue';
import Button from '@/components/Button.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';
import Modal from '@/components/Modal.vue';
import FormInput from '@/components/FormInput.vue';

import { Division, Service } from '@/libs/api.interfaces';

import { AxiosError } from 'axios';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import InvoiceTable from './InvoiceTable.vue';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    Button,
    SearchIcon,
    FileIcon,
    SearchRow,
    SearchField,
    Select,
    InvoiceTable,
    Modal,
    FormInput,
    ValidationObserver,
  },
})
export default class Invoice extends Vue {
  searchOpen = false;
  month: LabelValue | null = null;
  year: LabelValue | null = null;
  status: LabelValue | null = null;

  $refs!: {
    table: InvoiceTable;
  }

  selectedMerchants: { merchant_code: string; merchant_name: string } | null = null;
  loadingMerchant = false;
  merchants = [
    {
      /* eslint-disable @typescript-eslint/camelcase */
      merchant_code: '',
      merchant_name: 'Enter merchant name',
      $isDisabled: true,
      /* eslint-enable @typescript-eslint/camelcase */
    },
  ];

  loadingService = false;
  services: Service[] = [];
  selectedService: Service | null = null;
  selectedServiceGenerate: Service | null = null;

  loadingDivision = false;
  divisions: Division[] = [];
  selectedDivisionGenerate: Division | null = null;

  months = [
    {
      label: 'All',
      value: '0',
    }, ...[...Array(12)].map((_, i) => ({
      label: dayjs().month(i).format('MMMM'),
      value: (i + 1).toString().padStart(2, '00'),
    })),
  ];

  years = [{
    label: 'All',
    value: '0',
  },
  ...[...Array(15)].map((_, i) => {
    const now = dayjs().subtract(i, 'year').format('YYYY');
    return {
      label: now,
      value: now,
    };
  }),
  ]

  statuses = [
    {
      label: 'All',
      value: '0',
    }, {
      label: 'Pending',
      value: '2',
    }, {
      label: 'Generated',
      value: '3',
    },
  ]

  // modal
  showModal = false;
  loadingGenerate = false;
  selectedMerchantGenerate: { merchant_code: string; merchant_name: string } | null = null;
  monthFrom: LabelValue | null = null;
  yearFrom: LabelValue | null = null;
  monthTo: LabelValue | null = null;
  yearTo: LabelValue | null = null;
  monthsGenerate = this.months.slice(1);
  yearsGenerate = this.years.slice(1);

  toggleSearchOpen() {
    this.searchOpen = !this.searchOpen;
  }

  async mounted() {
    this.getService();
    this.parseParams();
  }

  @Watch('$route')
  onRouteChange() {
    this.parseParams();
  }

  async getMerchants(query: string) {
    if (query === '') return;

    try {
      this.loadingMerchant = true;
      const { data } = await api.get('/merchants', {
        params: {
          name: query,
        },
      });
      this.merchants = data.data;
      this.loadingMerchant = false;
    } catch (err) {
      console.error(err);
    }
  }

  async getService() {
    try {
      this.loadingService = true;
      const { data } = await api.get<Service[]>('/service');
      /* eslint-disable @typescript-eslint/camelcase */
      this.services = [{
        service_code: 'All',
        service_name: 'All',
        service_dbname: 'All',
      }, ...data];
      /* eslint-enable @typescript-eslint/camelcase */

      this.loadingService = false;
    } catch (err) {
      console.error(err);
    }
  }

  @Watch('selectedMerchantGenerate')
  @Watch('selectedServiceGenerate')
  checkGenerateSelected() {
    this.divisions = [];

    if (this.selectedMerchantGenerate && this.selectedServiceGenerate) {
      this.getDivisions();
    }
  }

  async getDivisions() {
    if (!this.selectedMerchantGenerate || !this.selectedServiceGenerate) return;

    /* eslint-disable @typescript-eslint/camelcase */
    try {
      this.loadingDivision = true;
      const { data } = await api.get<Division[]>('/division', {
        params: {
          merchant_code: this.selectedMerchantGenerate.merchant_code,
          service: this.selectedServiceGenerate.service_dbname,
        },
      });
      if (data.length > 0) {
        this.divisions = [{
          division_code: 'All',
          division_name: 'All',
          division_service: 'All',
        }, ...data];
      } else {
        this.divisions = data;
      }
      /* eslint-enable @typescript-eslint/camelcase */

      this.loadingDivision = false;
    } catch (err) {
      console.error(err);
    }
  }

  async generateInvoice() {
    if (!this.selectedMerchantGenerate
      || !this.selectedServiceGenerate
      || !this.selectedDivisionGenerate) return;

    try {
      /* eslint-disable @typescript-eslint/camelcase */
      this.loadingGenerate = true;
      await api.post('/merchant/generate-invoice ', {
        filter: {
          merchant_code: this.selectedMerchantGenerate.merchant_code,
          service: this.selectedServiceGenerate.service_dbname,
          division: this.selectedDivisionGenerate.division_code === 'All'
            ? undefined : this.selectedDivisionGenerate.division_code,
          periodStart: `${this.yearFrom?.value}-${this.monthFrom?.value}`,
          periodEnd: `${this.yearTo?.value}-${this.monthTo?.value}`,
        },
      });
      /* eslint-enable @typescript-eslint/camelcase */

      this.closeGenerateModal();

      this.month = null;
      this.year = null;
      this.status = null;
      this.selectedMerchants = null;
      this.selectedService = null;
      this.getInvoice(1);

      this.loadingGenerate = false;
    } catch (err) {
      console.error(err);
      this.loadingGenerate = false;
      const error = err as AxiosError;

      if (err.response) {
        showToast(ToastType.FAILED, `Error ${error.response?.status}`, 'Error when generating invoice');
      } else {
        showToast(ToastType.FAILED, 'Error', 'Error when generating invoice');
      }
    }
  }

  search() {
    this.$router.push({
      query: {
        mc: this.selectedMerchants === null ? undefined : JSON.stringify(this.selectedMerchants),
        mt: this.month === null ? undefined : this.month.value,
        yr: this.year === null ? undefined : this.year.value,
        st: this.status === null ? undefined : this.status.value,
        sv: this.selectedService === null ? undefined : JSON.stringify(this.selectedService),
      },
    });
  }

  cancel() {
    this.month = null;
    this.year = null;
    this.status = null;
    this.selectedMerchants = null;
    this.selectedService = null;

    this.$router.push({
      query: {},
    });
  }

  async getInvoice(page: number) {
    const params = {
      year: this.year,
      month: this.month,
      merchant: this.selectedMerchants,
      status: this.status,
      service: this.selectedService,
    };

    await this.$refs.table.getInvoice(params, page);
  }

  parseParams() {
    const params = this.$route.query;

    if (typeof params.yr === 'string') {
      const year = this.years.find((e) => e.value === params.yr);
      if (year) {
        this.year = year;
      }
    } else {
      this.year = null;
    }

    if (typeof params.mt === 'string') {
      const month = this.months.find((e) => e.value === params.mt);
      if (month) {
        this.month = month;
      }
    } else {
      this.month = null;
    }

    if (typeof params.mc === 'string') {
      const merchant = JSON.parse(params.mc);
      this.selectedMerchants = merchant;
    } else {
      this.selectedMerchants = null;
    }

    if (typeof params.st === 'string') {
      const status = this.statuses.find((e) => e.value === params.st);
      if (status) {
        this.status = status;
      } else {
        this.status = null;
      }
    }

    if (typeof params.sv === 'string') {
      const service = JSON.parse(params.sv);
      if (service) {
        this.selectedService = service;
      } else {
        this.status = null;
      }
    }

    let page = 1;
    if (typeof params.page === 'string') {
      page = Number(params.page);
    }

    this.getInvoice(page);
  }

  openGenerateModal() {
    this.showModal = true;
  }

  closeGenerateModal() {
    this.showModal = false;
  }
}
